import { useSelector } from "react-redux";
import { useReducer, useEffect, useMemo } from "react";
import { createRequestUsers, deleteRequestUsers, getUserTableGeneral, updateRequestUsers } from "../../config";
import { columnsUser } from "../../types/columnsTables/columnsUser";
import { rolUserTable } from "../../types/initStore/initUser";
import { MessageAnt } from "../../redux/slices/ui/uiAction";
import { changeDate } from "../../helpers/dayjsHelper";
import { MessageType } from "../../types/messageType";

const initialState = {
    isLoading: false,
    searchValue: "",
    tableData: [],
    activeModal: false,
    typeModal: 0,
    dataForm: {},
    countUser: 0,
    allAreas: [],
    allUser: [],
    loadingButton: false,
    selectedSection: 0,
};

function reducer(state, action) {
    switch (action.type) {
        case "SET_LOADING":
            return { ...state, isLoading: action.payload };
        case "SET_SEARCH_VALUE":
            return { ...state, searchValue: action.payload };
        case "SET_TABLE_DATA":
            return { ...state, tableData: action.payload };
        case "SET_ACTIVE_MODAL":
            return { ...state, activeModal: action.payload };
        case "SET_TYPE_MODAL":
            return { ...state, typeModal: action.payload };
        case "SET_DATA_FORM":
            return { ...state, dataForm: action.payload };
        case "SET_COUNT_USER":
            return { ...state, countUser: action.payload };
        case "SET_ALL_AREAS":
            return { ...state, allAreas: action.payload };
        case "SET_ALL_USER":
            return { ...state, allUser: action.payload };
        case "SET_LOADING_BUTTON":
            return { ...state, loadingButton: action.payload };
        case "SET_SELECTED_SECTION":
            return { ...state, selectedSection: action.payload };
        default:
            throw new Error(`Unknown action type: ${action.type}`);
    }
}

export const usePageUsersData = () => {
    const [state, dispatch] = useReducer(reducer, initialState);
    const globalState = useSelector((state) => state);

    const {
        auth: { isAdmin },
    } = useSelector((state) => state);
    let rolUser = rolUserTable;
    if (isAdmin) {
        rolUser = rolUserTable.filter((rol) => rol !== "SUPER_ADMIN");
    }
    const areasState = state.allAreas.map((area) => {
        return {
            text: area.name,
            value: area.name,
            color: area.color,
            uid: area._id,
        };
    });

    if (state.dataForm.startedDateApi) {
        const date = changeDate(state.dataForm.startedDateApi);
        state.dataForm.startedDate = date.day;
    }
    if (state.dataForm.fullTimeDateApi) {
        const date = changeDate(state.dataForm.fullTimeDateApi);
        state.dataForm.fullTimeDate = date.day;
    }

    const onFinish = (values) => {
        dispatch({ type: "SET_LOADING_BUTTON", payload: true });
        if (state.typeModal === 0) {
            createUser(values);
        } else {
            editUser(values);
        }
    };

    const onChangeSwitch = (value) => {
        changueTableUser(value);
        dispatch({ type: "SET_SELECTED_SECTION", payload: value });
    };

    const getAllTableUser = async () => {
        dispatch({ type: "SET_LOADING", payload: true });
        const {
            status,
            payload: { usersStatus: users, inmersysAreas: areas },
        } = await getUserTableGeneral();

        if (status > 0) {
            MessageAnt(MessageType.error, `Error al obtener usuarios`);
            dispatch({ type: "SET_LOADING", payload: false });
            return
        }
        const newArea = areas.filter((area) => area.isActive);

        dispatch({ type: "SET_ALL_AREAS", payload: newArea });
        const allUser = []
        const countUser = []

        users.forEach(statusUser => {
            const { _id: areActives, users } = statusUser;
            if (areActives) {
                countUser.unshift({ color: "#80e2a9", number: users.length, name: "Activos" })
            } else {
                countUser.push({ color: "#f87681", number: users.length, name: "Eliminados" })
            }

            allUser.push(...users);


        })
        dispatch({ type: "SET_TABLE_DATA", payload: allUser });

        dispatch({ type: "SET_ALL_USER", payload: allUser });
        dispatch({ type: "SET_COUNT_USER", payload: countUser });
        dispatch({ type: "SET_SELECTED_SECTION", payload: 0 });
        dispatch({ type: "SET_LOADING", payload: false });


    };

    const editAction = (form) => {
        if (form) {
            const areaType = form.area.map((area) => area.name);
            dispatch({
                type: "SET_DATA_FORM",
                payload: {
                    ...form,
                    area: areaType,
                    startedDate: null,
                    fullTimeDate: null,
                    startedDateApi: form.startedDate,
                    fullTimeDateApi: form.fullTimeDate,
                },
            });
        }
        dispatch({ type: "SET_TYPE_MODAL", payload: 1 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
    };

    const createUser = async (form) => {
        const { status } = await createRequestUsers(form);

        if (status > 0) {
            MessageAnt(MessageType.error, `Error al crear usuario`);
            return;
        }

        MessageAnt(MessageType.success, `Usuario creado`);
        dispatch({ type: "SET_LOADING_BUTTON", payload: false });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
        getAllTableUser();
    };

    const editUser = async (form) => {
        const { status } = await updateRequestUsers(form.email, form);
        if (status > 0) {
            MessageAnt(MessageType.error, `Error al editar usuario`);
            return;
        }
        MessageAnt(MessageType.success, `Usuario Editado`);
        dispatch({ type: "SET_LOADING_BUTTON", payload: false });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        getAllTableUser();
    };

    const deleteUser = async (key) => {
        const { status, payload } = await deleteRequestUsers(key);

        if (status > 0) {
            MessageAnt(MessageType.error, `Error al desactivar`);
            return;
        }

        let successMsg = payload.payload.isActive ? "reactivado" : "desactivado"

        MessageAnt(MessageType.success, `Usuario ${successMsg}`);
        getAllTableUser();
    };

    const changueTableUser = async (value) => {
        const userTable = state.allUser.filter((user) => user.isActive === (value === 0));
        dispatch({ type: "SET_TABLE_DATA", payload: userTable });
    };

    const handleOpenModalCreate = () => {
        dispatch({ type: "SET_DATA_FORM", payload: {} });
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: true });
    };

    const closeModal = () => {
        dispatch({ type: "SET_TYPE_MODAL", payload: 0 });
        dispatch({ type: "SET_ACTIVE_MODAL", payload: false });
    };

    const handleChange = (e) => {
        dispatch({ type: "SET_SEARCH_VALUE", payload: e.target.value });
    };

    const { columns } = columnsUser(editAction, deleteUser, { area: areasState, authuser: globalState.auth.email });

    const tableFilterDataUsers = useMemo(() => {
        return state.tableData.filter((item) => {
            return item.name.toLocaleLowerCase().includes(state.searchValue.toLocaleLowerCase());
        });
    }, [state.tableData, state.searchValue]);

    useEffect(() => {
        getAllTableUser();

    }, []);

    return {
        searchValue: state.searchValue,
        activeModal: state.activeModal,
        typeModal: state.typeModal,
        loadingButton: state.loadingButton,
        isLoading: state.isLoading,
        handleOpenModalCreate,
        closeModal,
        onFinish,
        tableFilterDataUsers,
        handleChange,
        columns,
        countUser: state.countUser,
        tableData: state.tableData,
        rolUser,
        allAreas: state.allAreas,
        onChangeSwitch,
        selectedSection: state.selectedSection,
        dataForm: state.dataForm,
    };
};
